import { render, staticRenderFns } from "./Ipm.vue?vue&type=template&id=7a347686&"
import script from "./Ipm.vue?vue&type=script&lang=js&"
export * from "./Ipm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports